export default {
    String: 'String', // String
    Number: 'Number', // Number
    ContactVerify: 'ContactVerify', // 联系方式验证
    Lock: 'Lock', // 锁定
    Date: 'Date', // 日期
    DateTime: 'DateTime', // 日期时间
    Status: 'Status', // 状态
    Stake: 'Stake', //桩号
    Smile: 'Smile' //笑脸
}
